import clsx from 'clsx'
import { FeedCardHeaderDropdownItemProps } from './feedCardHeaderDropdownItem.types'
import { DropdownItem } from './feedCardHeaderDropdownItem.styles'

const FeedCardHeaderDropdownItem = ({
  icon: Icon,
  label,
  borderBottom,
  className,
  onClick
}: FeedCardHeaderDropdownItemProps) => {
  return (
    <DropdownItem
      className={clsx(
        className,
        '_font-14 _d-flex _align-items-center _justify-content-start _text-gray-900 _px-4 _py-4 _text-nowrap _text-left',
        {
          '_border-bottom _border-gray-200': borderBottom
        }
      )}
      onClick={onClick}
    >
      <Icon size={20} className="_mr-3" />
      {label}
    </DropdownItem>
  )
}

export default FeedCardHeaderDropdownItem
